"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTileKey = generateTileKey;
exports.getNewEdges = exports.areTileUpdatesNeeded = exports.filterHiddenTiles = exports.convertMapComboResponseToArray = exports.getParcelInfoFromResponse = exports.getRowColFromResponse = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function generateTileKey(row, col) {
  return "r" + row + "_c" + col;
}
/**
 * Gets the row and column number from the
 * "boundaryManagerTile_355_160_9" section of the response string
 * @param responseKeyString
 * @returns {*}
 */


var getRowColFromResponse = function getRowColFromResponse(responseKeyString) {
  try {
    // Extra , is here because the first element is the full matching string
    var _$exec = /boundaryManagerTile_(\d+)_(\d+)/.exec(responseKeyString),
        _$exec2 = _slicedToArray(_$exec, 3),
        row = _$exec2[1],
        column = _$exec2[2];

    return {
      row: parseInt(row, 10),
      column: parseInt(column, 10)
    };
  } catch (e) {
    console.error('No tile match', e);
    return {};
  }
};
/**
 * Gets the json value from the response string and turns it into an actual JSON object
 * @param responseValueString
 * @returns {*}
 */


exports.getRowColFromResponse = getRowColFromResponse;

var getParcelInfoFromResponse = function getParcelInfoFromResponse(responseValueString) {
  try {
    return JSON.parse(responseValueString.trim().replace(/;/g, ''));
  } catch (e) {
    return {};
  }
};
/**
 * The map combo just returns a big string of boundary info that looks like the following
 * BoundaryTileRequest.responses["__boundaryManagerTile_355_160_9"] = {"regions":[{"id":16037,"name":"","type":6,"polygons":[]}],"children":[],"communities":[],"parcels":[]};
 * Because it's one big string, we need to split it up,
 * then pull the json off of it and parse it, and get the
 * row/column to use as the tile key for other uses (comparisons and whatnot)
 * @param responseString
 * @returns Array[
 *      {
 *         key: 'r355_c160',
 *         row: 355,
 *         column: 160,
 *         regions: [{id: 16037, name: '', type: 6, polygons: []}],
 *         children: [],
 *         polygons: [],
 *         communities: [],
 *         parcels:[]
 *      }
 * ]
 */


exports.getParcelInfoFromResponse = getParcelInfoFromResponse;

var convertMapComboResponseToArray = function convertMapComboResponseToArray(responseString) {
  return responseString.split('\n').filter(function (line) {
    return line !== '';
  }).reduce(function (acc, tileInfo) {
    var _tileInfo$split = tileInfo.split('='),
        _tileInfo$split2 = _slicedToArray(_tileInfo$split, 2),
        rawRowCol = _tileInfo$split2[0],
        rawParcel = _tileInfo$split2[1];

    var rowCol = getRowColFromResponse(rawRowCol);
    var parcelData = getParcelInfoFromResponse(rawParcel);
    return !(0, _isEmpty2.default)(rowCol) && !(0, _isEmpty2.default)(parcelData) ? [].concat(_toConsumableArray(acc), [_objectSpread({}, parcelData, rowCol, {
      key: generateTileKey(rowCol.row, rowCol.column)
    })]) : acc;
  }, []);
};
/**
 * Gets the edges of the current grid and filters out any old tiles
 * that are outside of the grid.
 * @param newEdges
 * @param oldTiles
 * @returns {*} Any tiles that should be dropped because they are outside the current grid
 */


exports.convertMapComboResponseToArray = convertMapComboResponseToArray;

var filterHiddenTiles = function filterHiddenTiles(newEdges, oldTiles) {
  if (oldTiles.length === 0) {
    return oldTiles;
  }

  var left = newEdges.left,
      right = newEdges.right,
      bottom = newEdges.bottom,
      top = newEdges.top;
  return oldTiles.filter(function (tile) {
    var row = tile.row,
        column = tile.column;
    return column >= left && column <= right && row <= bottom && row >= top;
  });
};
/**
 * Checks the new tile grid against the previous edges. If the new tile grid is outside
 * of the previous edges, we need to fetch new tiles.
 * @param newTiles
 * @param edges
 * @returns {boolean}
 */


exports.filterHiddenTiles = filterHiddenTiles;

var areTileUpdatesNeeded = function areTileUpdatesNeeded(newTiles, edges) {
  if ((0, _isEmpty2.default)(edges)) {
    return true;
  }

  var firstNewTile = newTiles[0];
  var lastNewTile = newTiles[newTiles.length - 1];
  var left = edges.left,
      right = edges.right,
      bottom = edges.bottom,
      top = edges.top;
  return firstNewTile.column < left || lastNewTile.column > right || firstNewTile.row < top || lastNewTile.row > bottom;
};
/**
 * Takes newly fetched tiles and compares against previous edges. Using the new tiles and
 * the old edges we calculate the new grid edges.
 * @param newTiles Array[Object{row: Number, column: number}]
 * @param oldEdges Object{left: Number, right: Number, top: Number, bottom: Number}
 * @returns {*}
 */


exports.areTileUpdatesNeeded = areTileUpdatesNeeded;

var getNewEdges = function getNewEdges(newTiles, oldEdges) {
  var firstNewTile = newTiles[0];
  var lastNewTile = newTiles[newTiles.length - 1];

  if (!firstNewTile || !lastNewTile) {
    return oldEdges;
  }

  if ((0, _isEmpty2.default)(oldEdges)) {
    return {
      left: firstNewTile.column,
      right: lastNewTile.column,
      top: firstNewTile.row,
      bottom: lastNewTile.row
    };
  }

  var newEdges = _objectSpread({}, oldEdges); // If the user panned left


  if (firstNewTile.column < oldEdges.left) {
    newEdges.left = firstNewTile.column;
    newEdges.right = oldEdges.right - Math.abs(firstNewTile.column - oldEdges.left);
  } // If the user panned right


  if (lastNewTile.column > oldEdges.right) {
    newEdges.right = lastNewTile.column;
    newEdges.left = oldEdges.left + Math.abs(lastNewTile.column - oldEdges.right);
  } // If the user panned up


  if (firstNewTile.row < oldEdges.top) {
    newEdges.top = firstNewTile.row;
    newEdges.bottom = oldEdges.bottom - Math.abs(firstNewTile.row - oldEdges.top);
  } // If the user panned down


  if (lastNewTile.row > oldEdges.bottom) {
    newEdges.bottom = lastNewTile.row;
    newEdges.top = oldEdges.top + Math.abs(lastNewTile.row - oldEdges.bottom);
  }

  return newEdges;
};

exports.getNewEdges = getNewEdges;